module.exports = __webpack_public_path__ + "img/IND-A-2-I.d4678ded.png";